import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategorySection() {
  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-lg md:text-xl font-bold text-foreground-900 font-heading">
            漫画分类
          </h2>
          <p className="text-sm text-foreground-500 mt-1">探索你喜欢的韩漫类型</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center p-5 md:p-6 rounded-xl bg-background-100 hover:bg-primary-50 transition-all duration-300"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 group-hover:bg-primary-100 group-hover:text-primary-600 transition-all mb-3">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-400 mt-1">{cat.count} 部作品</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}